var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOwnerSupportV2(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5H3.33333C2.87333 17.5 2.5 17.1267 2.5 16.6667V11.6667C2.5 11.2067 2.87333 10.8333 3.33333 10.8333H5C5.46 10.8333 5.83333 11.2067 5.83333 11.6667V16.6667C5.83333 17.1267 5.46 17.5 5 17.5Z",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667H12.7774C13.1383 14.1667 13.4891 14.05 13.7774 13.8333L15.7908 12.3233C16.2933 11.9467 16.9966 11.9967 17.4408 12.4408V12.4408C17.9341 12.9342 17.9341 13.7333 17.4408 14.2258L15.7133 15.9533C15.2483 16.4183 14.6549 16.7358 14.0099 16.865L11.5683 17.3533C11.0841 17.45 10.5849 17.4383 10.1058 17.3183L7.89742 16.7667C7.63325 16.7 7.36242 16.6667 7.08992 16.6667H5.83325",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.1667H12.0708C12.7683 14.1667 13.3333 13.6017 13.3333 12.9042V12.6517C13.3333 12.0725 12.9391 11.5675 12.3774 11.4275L10.4674 10.95C10.1566 10.8725 9.83825 10.8333 9.51825 10.8333V10.8333C8.74575 10.8333 7.98992 11.0617 7.34742 11.4908L5.83325 12.5",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7407 2.93503C16.9624 3.11253 17.6257 4.3067 17.4799 5.30837C17.1849 7.34087 13.5407 8.51003 13.4791 8.5017C13.4174 8.49253 10.2574 6.3342 10.5524 4.30253C10.6982 3.30087 11.6732 2.34503 12.8949 2.52253C13.5932 2.6242 14.0049 3.01753 14.2274 3.3467C14.5357 3.09337 15.0424 2.83337 15.7407 2.93503V2.93503Z",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerSupportV2);
export default __webpack_public_path__ + "static/media/ownerSupportV2.aab4bd0c24dd3691f26c42c252ed668c.svg";
export { ForwardRef as ReactComponent };